import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import BlogIcon from 'assets/icons/initiativePost'
import DiscussionIcon from 'assets/icons/initiativeDiscussion'
import ApplianceIcon from 'src/custom/gns3/icons/appliance'
import LabIcon from 'src/custom/gns3/icons/lab'
import PodcastIcon from 'src/custom/gns3/icons/podcast'
import QuestionIcon from 'src/custom/gns3/icons/question'
import SoftwareIcon from 'src/custom/gns3/icons/software'
import TrainingIcon from 'src/custom/gns3/icons/training'

// TODO: Do this better
// We don't know yet how this should work - won't be hardcoded to gns3 icons as it is now
// I assume we will probably make a generic "icon library"
// that users can choose icons from - SY
// See PR #427
const icons = {
   appliance: ApplianceIcon,
   blog: BlogIcon,
   discussion: DiscussionIcon,
   lab: LabIcon,
   question: QuestionIcon,
   podcast: PodcastIcon,
   software: SoftwareIcon,
   training: TrainingIcon
}

const InitiativeDefaultThumbnail = ({ highlightColor, iconName }) => {
   const Icon = icons[iconName] || 'div'

   return (
      <View
         display="flex"
         justifyContent="center"
         alignItems="center"
         width="100%"
         height="100%"
         backgroundColor={highlightColor || '#eee'}>
         <Icon width="50%" height="50%" color="#fff" />
      </View>
   )
}

InitiativeDefaultThumbnail.propTypes = {
   highlightColor: PropTypes.string,
   iconName: PropTypes.string
}

InitiativeDefaultThumbnail.defaultProps = {
   highlightColor: undefined,
   iconName: undefined
}

export default InitiativeDefaultThumbnail
